import { Component, Input } from '@angular/core';
import { textLabelOptionInterface } from '../../../types/interfaces/text-label.interface';

@Component({
  selector: 'app-text-label',
  imports: [],
  templateUrl: './text-label.html',
  styleUrl: './text-label.css',
})
export class TextLabel {
  @Input()
  public label: string = '';

  @Input()
  public options?: textLabelOptionInterface;
}
